export default "__VITE_ASSET__gEw20q6r__"